import { Pagination as AntdPagination, PaginationProps } from "antd";

export interface CustomPaginationProps {
  total: number;
  onChange: (currentPage: number, pageSize: number) => {};
}

export const Pagination = ({ total, onChange }: CustomPaginationProps) => {
  const showTotal: PaginationProps["showTotal"] = (total) =>
    `Total ${total} items`;

  return (
    <AntdPagination
      size="small"
      total={total}
      showTotal={showTotal}
      onChange={onChange}
      pageSizeOptions={[10, 15, 30, 50]}
    />
  );
};
